<template>
  <form>
    <base-modal has-close-button secondary target="kycDocumentSubmit" title="Submit Document">
      <base-field v-if="!type" label="Type">
        <base-select
          v-model="payload.type"
          :options="options"
          placeholder="document type" />
      </base-field>
      <slot />
      <template v-slot:footer>
        <button-upload :path="`users/${$auth.user._id}/kyc`" primary tag="kyc" @uploaded="afterUpload">Upload</button-upload>
      </template>
    </base-modal>
  </form>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import ButtonUpload from './ButtonUpload.vue'

export default {
  name: 'KycDocumentSubmit',

  components: {
    ButtonUpload
  },

  props: {
    type: {
      default: null,
      type: String
    }
  },

  data: () => ({
    options: [],
    payload: {}
  }),

  async created () {
    this.payload = this.$_.clone(this.schema)

    if (this.type) {
      this.payload.type = this.type
    } else {
      await this.getDocumentTypes()

      this.options = this.$collection.toOptions(this.types)
    }
  },

  computed: {
    ...mapGetters({
      schema: 'core/kyc/schema'
    }),

    ...mapState({
      kyc: store => store.core.kyc.entity,
      types: store => store.core.kyc.types
    })
  },

  methods: {
    async afterUpload (document) {
      this.payload.user = this.$auth.user._id
      this.payload.document = document._id

      await this.saveKyc(this.payload)

      this.$emit('submitted', this.kyc)
    },

    ...mapActions({
      getDocumentTypes: 'core/kyc/types',
      saveKyc: 'core/kyc/create'
    })
  }
}
</script>
